import { ArrowRight } from 'lucide-react'
import './LandingBeforeAfter.css'

interface Props {
  onStart: () => void
}

export function LandingBeforeAfter({ onStart }: Props) {
  return (
    <section className="before-after">
      <div className="ba-inner">
        <div className="ba-header">
          <h2 className="ba-title">Der Unterschied ist beeindruckend</h2>
          <p className="ba-subtitle">Von chaotischem Text-Export zu einem eleganten, lesbaren Archiv</p>
        </div>

        <div className="ba-grid">
          {/* ── VORHER ── */}
          <div className="ba-card before">
            <div className="ba-label before-label">VORHER</div>
            <h3 className="ba-card-title">Der rohe Text-Export</h3>
            <div className="ba-preview before-preview">
              <pre>{`[01.01.2025, 14:23] Anna: Hey!
[01.01.2025, 14:24] Max: Hallo :)
[01.01.2025, 14:24] Anna: Wie geht's?
[01.01.2025, 14:25] Max: Gut! <Medien weggelassen>
[01.01.2025, 14:25] Anna: Schönes Foto
[01.01.2025, 14:27] Max: Danke :)
[01.01.2025, 14:28] Anna: ...`}</pre>
            </div>
            <ul className="ba-points">
              <li className="ba-point bad"><span className="ba-x">✗</span> Unleserliches Format</li>
              <li className="ba-point bad"><span className="ba-x">✗</span> Bilder fehlen</li>
              <li className="ba-point bad"><span className="ba-x">✗</span> Keine emotionale Wirkung</li>
            </ul>
          </div>

          {/* ── NACHHER ── */}
          <div className="ba-card after">
            <div className="ba-label after-label">NACHHER</div>
            <h3 className="ba-card-title">Dein ChatArchiv-PDF</h3>
            <div className="ba-preview after-preview">
              <div className="ba-chat-header">
                <div className="ba-chat-avatar">A</div>
                <div>
                  <div className="ba-chat-name">Anna &amp; Max</div>
                  <div className="ba-chat-sub">WhatsApp Chat Archiv</div>
                </div>
              </div>
              <div className="ba-messages">
                <div className="ba-msg left">Hey! 👋<span className="ba-time">14:23</span></div>
                <div className="ba-msg right">Hallo Anna 😊<span className="ba-time">14:24</span></div>
                <div className="ba-msg left">Wie geht's?<span className="ba-time">14:24</span></div>
                <div className="ba-msg right">Gut, danke! 💚<span className="ba-time">14:25</span></div>
              </div>
            </div>
            <ul className="ba-points">
              <li className="ba-point good"><span className="ba-check">✓</span> Wunderschön formatiert</li>
              <li className="ba-point good"><span className="ba-check">✓</span> Bilder &amp; Emojis integriert</li>
              <li className="ba-point good"><span className="ba-check">✓</span> Erinnerungen zum Leben erweckt</li>
            </ul>
          </div>
        </div>

        <div className="ba-cta">
          <button className="ba-cta-btn" onClick={onStart}>
            Jetzt dein Chat-Archiv erstellen
            <ArrowRight size={20} />
          </button>
        </div>
      </div>
    </section>
  )
}
